<template>
  <portlet
      :icon="'fad fa-file-contract'"
      :title="'Contract Bewerken'"
      :actionsBlock="true"
      :footer="true"
  >
    <template slot="actionsBlock">
      <router-link tag="button" :to="{name:'contracts'}" class="btn btn-secondary">
        <i class="fas fa-long-arrow-left mr-2"></i>
        Terug
      </router-link>
    </template>

    <template slot="portletBody">
      <form @submit.prevent="saveContract">
        <div class="row">
          <div class="col-lg-6">
            <!-- Other form fields will go here -->
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="form-group col-lg-6">
                <label>ID (voorkant) <span class="text-danger">*</span></label>
                <file-select v-validate="'required'" name="idFront" v-model="contract.idFront"></file-select>
                <span v-if="errors.first('idFront')" class="small text-danger">Dit veld is verplicht</span>
              </div>
              <div class="form-group col-lg-6">
                <label>ID (achterkant) <span class="text-danger">*</span></label>
                <file-select v-validate="'required'" name="idBack" v-model="contract.idBack"></file-select>
                <span v-if="errors.first('idBack')" class="small text-danger">Dit veld is verplicht</span>
              </div>
              <div class="form-group col-lg-6">
                <label>Bankpas <span class="text-danger">*</span></label>
                <file-select v-validate="'required'" name="bankCard" v-model="contract.bankCard"></file-select>
                <span v-if="errors.first('bankCard')" class="small text-danger">Dit veld is verplicht</span>
              </div>
              <div class="form-group col-lg-6">
                <label>Rijbewijs</label>
                <file-select name="driversLicense" v-model="contract.driversLicense"></file-select>
              </div>
              <div class="form-group col-lg-6">
                <label>BSN Document <span class="text-danger" v-if="!contract.isDutch">*</span></label>
                <file-select name="bsnDocument" v-model="contract.bsnDocument" :disabled="contract.isDutch"></file-select>
                <span v-if="errors.first('bsnDocument')" class="small text-danger">Dit veld is verplicht</span>
              </div>
              <div class="form-group col-lg-12">
                <label for="remark">Opmerking</label>
                <textarea id="remark" name="remark" class="form-control" v-model="contract.remark"></textarea>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>

    <div slot="portletFooter" class="col text-right">
      <button @click="saveContract" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
import FileSelect from '../../components/fileSelect';
import {mapActions} from "vuex";

export default {
  name: "EditContracts",
  components: {FileSelect},
  data() {
    return {
      contract: {
        remark: '',
        idFront: null,
        idBack: null,
        bankCard: null,
        driversLicense: null,
        bsnDocument: null,
        isDutch: true
      }
    };
  },
  methods: {
    ...mapActions({
      patchContract: 'contracts/patch'
    }),
    async saveContract() {
      const result = await this.$validator.validate();
      if (!result) {
        this.$toasted.global.failedFormRequest();
        return;
      }

      try {
        const contractToSave = {
          id: this.$route.params.id, // Assuming the id is in the route params
          ...this.contract
        };

        await this.patchContract(contractToSave);

        this.$router.push({name: 'contracts'});
        this.$toasted.global.successRequest({
          message: 'Contract bijgewerkt'
        });
      } catch (error) {
        console.error(error);
        this.$toasted.global.failedRequest();
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>